import styles from './Arrow.module.scss';

export const NextArrow = ({ currentSlide, slideCount, arrowLocation, ...props }) => {

    return(
      <button
      {...props}
      className={
        `${styles.slickNext} ${styles.slickArrow}`  +
        (arrowLocation == "top" ? ` ${styles.topLocation}` : "" ) 
          // + (currentSlide  == slideCount - 1 ? `${styles.slickDisabled}` : "")
        }
        aria-disabled={currentSlide === slideCount - 1 ? true : false}
        type="button"
      >
        <i className="bi bi-chevron-right"></i>
      </button>
    )
  }
